// @flow
import Bowser from 'bowser'
import { Storage } from 'utils/storage'
import type { ServiceInfo } from 'core/types'

/**
 * Is IOs device
 */
export const isIos = () => {
  const iOs =
    !!navigator.platform &&
    /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator|MacIntel/.test(navigator.platform)

  return iOs
}

/**
 * Check device type
 * @return {string} 'mobile'|'desktop'
 */
export const detectDeviceType = (): 'mobile' | 'desktop' => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'mobile'
    : 'desktop'
}

/**
 * Check what element is visible in viewport
 * @param {HTMLElement} el
 * @param {} partiallyVisible
 */
export const elementIsVisibleInViewport = (el: HTMLElement, partiallyVisible: boolean = false) => {
  const { top, left, bottom, right } = el.getBoundingClientRect()
  const { innerHeight, innerWidth } = window

  return partiallyVisible
    ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth
}

/**
 * Check what browser tab of the page is focused
 * @return {boolean}
 */
export const isBrowserTabFocused = (): boolean => !document.hidden

export const canUseWebP = (): boolean => {
  const elem = document.createElement('canvas')

  if (elem.getContext && elem.getContext('2d')) {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
  }

  // very old browser like IE 8, canvas not supported
  return false
}

export const isSafari = (): boolean => {
  const ua = navigator.userAgent.toLowerCase()

  return ua.includes('safari') && !ua.includes('chrome')
}

export const isIE = (versionMatcher: string = '<=11'): boolean => {
  const browser = Bowser.getParser(window.navigator.userAgent)

  return browser.satisfies({ ie: versionMatcher })
}

export const isEdge = (versionMatcher: string = '<=18'): boolean => {
  const browser = Bowser.getParser(window.navigator.userAgent)

  return browser.satisfies({ edge: versionMatcher })
}

/**
 * Is Yandex Turbo App
 */
export const isYandexTurboApp = (): boolean => {
  const isYandexApp = Boolean(window && window.yandex && window.yandex.app)
  const serv: ServiceInfo = Storage.getJson('service') || {}
  const isEmulatedYandexApp = Boolean(serv.turboApp)

  return isYandexApp || isEmulatedYandexApp
}
